import { ActionState, ActionStateEnum, IdleCreateState, IdleConstruction } from "..";

import { EntityManager } from "../../plan/EntityManager";
import { GameObjectManager } from "../../plan/GameObjectManager";
import { PlanManager } from "../../../../cocosPlan";
import { Commands, Entity, EntityDefaultPropertiesManager, EntityFactory, Events, eventsManager, math, roomManager, SavaneConstants, SavaneMath, TemporaryWall, Wall, wallManager } from "@rhinov/savane-js";

declare var cc: any;

export class CreateWallState extends ActionState {

    _wallCreationDone: boolean = false;
    _wallAnimCreation: boolean = false;
    _endWallsSelected: Wall[] | null = null;
    _beginWallsCut: Wall[] | null = null;
    _lastCursorPosition: math.vec3 | null = null;
    _dragging: boolean = false;
    state = ActionStateEnum.createWall;
    createSeveralWalls: boolean;
    _beginWallsSelected: Wall[] | null;
    _wall: Wall | null = null;
    
    constructor(cursorPosition: math.vec3, wallsSelected: any, createSeveralWalls: boolean) {
        super();
        
        
        this._beginWallsSelected = wallManager.getWallsAtCorner(cursorPosition, PlanManager.getInstance().world.currentScene!.currentFloor!, SavaneConstants.PositionTolerance);
        if (this._beginWallsSelected === null) {
            this._beginWallsCut = wallManager.getWallsAtPosition(cursorPosition, PlanManager.getInstance().world.currentScene!.currentFloor!, SavaneConstants.PositionTolerance, -1);
        }

        
        this.createSeveralWalls = createSeveralWalls;
        this.startWall(cursorPosition);
        PlanManager.getInstance().updateItemsSelected(null);
    }

    getAction (): number {
        if (this.createSeveralWalls)
            return ActionStateEnum.createMultipleWalls;
        else
            return ActionStateEnum.createWall;
    }

    startWall (cursorPosition: math.vec3) {
        this._wall = EntityFactory.getInstance().createWall(math.vec3.clone(cursorPosition),
            math.vec3.clone(cursorPosition));
        EntityDefaultPropertiesManager.getInstance().convertWallToDefaultProperties(this._wall);

        this._wall.startTemporary();
        (this._wall.temporary as TemporaryWall).canBeSuperposed = true;
        PlanManager.getInstance().addWall(this._wall, false);
        //Node update
        var node = EntityManager.getInstance().getNode(this._wall);
        node!.setSelected(true);
    }

    commitWall (wallsSelected: Wall[]) {
        var planManager = PlanManager.getInstance();
        if (this._wall!.isValid(PlanManager.getInstance().world.currentScene!.currentFloor!)) {

            var wallsBegin = wallManager.getWallsAtPosition(this._wall!.begin, PlanManager.getInstance().world.currentScene!.currentFloor!, SavaneConstants.PositionTolerance, this._wall!.id);
            var wallsEnd = wallManager.getWallsAtPosition(this._wall!.end, PlanManager.getInstance().world.currentScene!.currentFloor!, SavaneConstants.PositionTolerance, this._wall!.id);
            var startHeight = -1;
            var endHeight = -1;
            if (wallsBegin) {
                startHeight = wallsBegin[0].height;
                for (var i = 1 ; i < wallsBegin.length ; i++) {
                    if (startHeight !== wallsBegin[i].height) {
                        startHeight = -1;
                        break;
                    }
                }
            }
            if (wallsEnd) {
                endHeight = wallsEnd[0].height;
                for (var i = 1 ; i < wallsEnd.length ; i++) {
                    if (endHeight !== wallsEnd[i].height) {
                        endHeight = -1;
                        break;
                    }
                }
            }
            if (startHeight !== -1 && endHeight !== -1) {
                if (startHeight !== endHeight) {
                    startHeight = -1;
                    endHeight = -1;
                }
            }
            if (startHeight === -1 && endHeight === -1) {
                var room = roomManager.getRoomAtPosition(this._wall!.center, PlanManager.getInstance().world.currentScene!.currentFloor!);
                if (room) {
                    EntityDefaultPropertiesManager.getInstance().setWallDefaultHeight(room.height);
                }
            }
            else {
                if (startHeight !== -1) {
                    EntityDefaultPropertiesManager.getInstance().setWallDefaultHeight(startHeight);
                }
                if (endHeight !== -1) {
                    EntityDefaultPropertiesManager.getInstance().setWallDefaultHeight(endHeight);
                }
            }

            EntityDefaultPropertiesManager.getInstance().convertWallToDefaultProperties(this._wall!);

            planManager.updateItemsSelected(null);
            planManager.deleteWall(this._wall!.id);
            this._wall!.saveAndEndTemporary();
            this._wall!.parent = PlanManager.getInstance().world.currentScene!.currentFloor!;
            planManager.executeCommand(new Commands.CreateWallCommand(this._wall!, PlanManager.getInstance().selectedEntities, false));

            // Tutorial start
            eventsManager.instance.dispatch(Events.PLAN_TUTO_START, 6);
            eventsManager.instance.dispatch(Events.PLAN_TUTO_START, 12);
            // End tutorial

            this._wall = null;
        } else {
            if (!this.createSeveralWalls) {
                planManager.deleteWall(this._wall!.id);
                this.updateAdjacentWalls(wallsSelected);
                this._wall = null;
            }
        }
    }

    cancelWall () {
        PlanManager.getInstance().deleteWall(this._wall!.id);
    }

    mouseClickCancelled (cursorPosition: math.vec3): ActionState | null {
        GameObjectManager.deleteCutDimension(true);
        PlanManager.getInstance().updateItemsSelected(null);
        eventsManager.instance.dispatch(Events.PLAN_STATE_CHANGED, ActionStateEnum.IdleConstruction);
        return new IdleConstruction();
    }

    updateWallCreation (cursorPosition: math.vec3, wallsSelected: Wall[]) {
        this._wall!.end = cursorPosition;
        if (this._wallCreationDone) {
            this._wallCreationDone = false;
            this._wallAnimCreation = false;
        }
        if (this._wall!.length > 0) {
            this.updateAdjacentWalls(wallsSelected);
        }
        EntityDefaultPropertiesManager.getInstance().convertWallToDefaultProperties(this._wall!);
        GameObjectManager.drawWall(this._wall!, this._wall!.isValid(PlanManager.getInstance().world.currentScene!.currentFloor!), true, false);
    }

    moveMouseCursor (cursorPosition: math.vec3, hoverEntities?: any[], planpos?: math.vec3): ActionState | null {
        const wallsSelected = hoverEntities as any;
        super.moveMouseCursor(cursorPosition, hoverEntities, planpos);
        if ((this._lastCursorPosition !== null) && (math.vec3.distance(this._lastCursorPosition, cursorPosition) > SavaneConstants.PositionTolerance)) {
            this._dragging = true;
        }
        else {
            if (this._lastCursorPosition === null) {
                this._dragging = false;
                this._lastCursorPosition = math.vec3.clone(cursorPosition);
            }
        }

        if (this._beginWallsCut !== null && this._beginWallsCut.length === 1) {
            GameObjectManager.drawCutDimension(this._wall!.begin, this._beginWallsCut[0], cursorPosition, true);
        }
        this.updateWallCreation(cursorPosition, wallsSelected);
        return null;
    }

    mouseClickUp (cursorPosition: math.vec3, elapsedTime: number, hoverEntities: any[], mouseButton: number): ActionState | null {
        GameObjectManager.deleteCutDimension(true);
        if (this.createSeveralWalls) {
            return null;
        }
        else {
            //this.updateWallCreation(cursorPosition,wallsSelected);

            if (this._dragging) {
                this.commitWall(hoverEntities as any);
                return new IdleCreateState();
            }
            else {
                eventsManager.instance.dispatch(Events.PLAN_STATE_CHANGED, ActionStateEnum.IdleConstruction);
                return new IdleConstruction();
            }

        }
    }

    mouseClickDown (cursorPosition: math.vec3, doubleClick: boolean, hoverEntities: any[], mouseButton: number): ActionState | null {
        if (mouseButton === 2) {
            return PlanManager.getInstance().mouseClickCancelled();
        }
        
        this._lastCursorPosition = math.vec3.clone(cursorPosition);

        var planManager = PlanManager.getInstance();
        if (this.createSeveralWalls && this._wall) {
            if (SavaneMath.equal(cursorPosition, this._wall.begin)) {
                planManager.deleteWall(this._wall.id);
                return new IdleCreateState(this.createSeveralWalls);
            }

            this.updateWallCreation(cursorPosition, hoverEntities);
            this.commitWall(hoverEntities);
            if (hoverEntities !== null && hoverEntities.length !== 0) {
                return new IdleCreateState(this.createSeveralWalls);
            }
            if (this._wall === null) {
                return new CreateWallState(cursorPosition, hoverEntities, this.createSeveralWalls);
            } else {
                return null;
            }
        } else {
            return null;
        }

    }

    mouseIdle (cursorPosition: math.vec3, hoverEntities: Array<Entity>, dt: number): ActionState | null {
        return null;
    }

    keyPressed (keyCode: number, ctrl?: boolean, alt?: boolean): ActionState | null {
        if (keyCode == cc.KEY.escape) {
            PlanManager.getInstance().updateItemsSelected(null);
            eventsManager.instance.dispatch(Events.PLAN_STATE_CHANGED, ActionStateEnum.IdleConstruction);
            return new IdleConstruction();
        }

        return null;
    }

    onButton (buttonId: number) {
        this.cancelWall();
        return true;
    }

    updateAdjacentWalls (wallsSelected: Wall[] | null) {
        var i;
        if (this._wall !== null) {
            if (this._endWallsSelected !== null) {
                for (i = 0; i < this._endWallsSelected.length; i++) {
                    GameObjectManager.drawWall(this._endWallsSelected[i], true, false, false);
                }
            }

            if (this._beginWallsSelected !== null) {
                for (i = 0; i < this._beginWallsSelected.length; i++) {
                    GameObjectManager.drawWall(this._beginWallsSelected[i], true, false, false);
                }
            }
            this._endWallsSelected = wallsSelected;

            if (this._endWallsSelected !== null) {
                for (i = 0; i < this._endWallsSelected.length; i++) {
                    GameObjectManager.drawWall(this._endWallsSelected[i], true, false, false);
                }
            }
        }
    }

    get beginPoint(): math.vec3 {
        return this._wall!.begin;
    }

    get editedPoint(): math.vec3 {
        return this._wall!.end;
    }

    get wall(): Wall | null {
        return this._wall;
    }
    dispose () {
        if (this._wall !== null) {
            PlanManager.getInstance().deleteWall(this._wall.id);
        }
        this.updateAdjacentWalls(null);
    }
}